import { HttpContextToken, HttpRequest } from '@angular/common/http';

export const SkipByHttpErrorInterceptorContext = new HttpContextToken(
  () => true,
);

export const isSkippedByHttpErrorInterceptorContext = <Body>(
  request: HttpRequest<Body>,
): boolean => {
  return request.context.has(SkipByHttpErrorInterceptorContext);
};
